import React from "react";
import "./HimalyanDiamond.css"; // Import your CSS for styling
import prodImg from "../../assets/PackageImages/GoshalaGold(Pink).png";
import { projects } from "../../data/projectsData";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NutritionalTable from "./NutritionalTable";
import { useMediaQuery, useTheme } from "@mui/material";

const GopalanDiamond = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );
  const tableData = [
    { nutrient: "Protein", value: "23%" },
    { nutrient: "Fat", value: "3.5 - 4%" },
    { nutrient: "Fiber", value: "10%" },
    { nutrient: "Moisture", value: "10 - 11%" },
    { nutrient: "Insoluble Matter", value: "2%" },
  ];

  return (
    <div className="product-container">
      <div className="product-details">
        <div className={isMobile ? "product-image product-image--mobile" : "product-image"}>
          <img
            src={prodImg} // Replace with the actual image path
            alt="Himalaya Diamond Premium"
          />
        </div>
        <div className="product-info">
          <div>
            <div className="product-title">
              GOPALAN GOLD{" "}
              <span
                style={{
                  fontFamily: "Playfair Display",
                  fontStyle: "italic",
                  color: "#ffc40c",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                }}
              >
                (Premium)
              </span>
            </div>
            <div
              style={{
                textAlign: "justify",
              }}
            >
              <p>
                Gopalan Gold (TYPE 1) is a premium soybean-based cattle feed
                formulated to optimize milk production and support the overall
                health of your dairy cows. Available in convenient 5mm pellets,
                this nutritious feed is designed to provide essential nutrients
                for peak performance.
              </p>
              <p>
                Experience the difference with Gopalan Gold. Provide your dairy
                cattle with the nutrition they need to thrive and produce
                high-quality milk.
              </p>
            </div>
          </div>
          <div>
            <h3 className="benefits-title">KEY BENEFITS:</h3>
            <div className="benefits">
              <ul>
                <li className="benefit">
                  <div>
                    <b>Enhanced Digestion:</b> The unique combination of buffer
                    and yeast in Gopalan Gold helps maintain an optimal pH level
                    in the rumen, promoting efficient digestion and nutrient
                    absorption.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Balanced Nutrition:</b> Packed with essential ingredients
                    like rice bran, jaggery, grains, seed cakes, vitamins, and
                    minerals, Gopalan Gold provides a complete and balanced diet
                    to support your cattle's nutritional needs.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Improved Milk Production:</b> By optimizing digestion and
                    nutrient absorption, Gopalan Gold helps maximize milk yield
                    and quality, ensuring your dairy cows reach their full
                    potential.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Longer Lactation Periods:</b> This fortified feed is
                    designed to support extended lactation periods, helping you
                    maintain consistent milk production throughout the year.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Overall Health and Well-being:</b> Gopalan Gold promotes
                    the overall health and well-being of your cattle, reducing
                    the risk of diseases and ensuring optimal performance.
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <NutritionalTable data={tableData} />
          </div>
          <div>
            <h3 className="benefits-title">Ideal for:</h3>
            <ul className="benefits">
              <li className="benefit">
                <div>Dairy cows seeking to maximize milk production.</div>
              </li>
              <li>
                <div>Cattle looking to extend their lactation periods.</div>
              </li>
              <li>
                <div>
                  Farmers prioritizing the health and well-being of their herd.
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="other-products">
        <Typography variant="h6" gutterBottom>
          Products Catalogue
        </Typography>
        <List>
          {otherProducts.map((product) => {
            return (
              <ListItem
                key={product.id}
                component={Link}
                to={`/products/${product.id}`}
                style={{
                  borderBottom: "1px lightgray dotted",
                  color: "black",
                  ...(product.id === "Gopalan-diamond-pellets" && {
                    backgroundColor: "#4caf50",
                    color: "white",
                    borderRadius: "1rem",
                  }),
                }}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                  }}
                >
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  primary={product.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default GopalanDiamond;
